/* VIP support block: QR codes and sign out.
/* Bundled into built/casper.js after assets/js/lib/qrcode.js, so the global
/* `qrcode` from that library is already defined by the time this runs. */

(function () {
    /* Draws a QR for every [data-vip-qr] element, using the URL in the attribute.
       The SVG is scalable, so the size comes from CSS rather than from here. */
    function renderQrCodes() {
        if (typeof qrcode === 'undefined') {
            return;
        }

        var targets = document.querySelectorAll('[data-vip-qr]');

        for (var i = 0; i < targets.length; i += 1) {
            var el = targets[i];
            var url = el.getAttribute('data-vip-qr');

            /* Skip the ones already drawn, so a second call is harmless */
            if (!url || el.firstElementChild) {
                continue;
            }

            try {
                var qr = qrcode(0, 'M');
                qr.addData(url);
                qr.make();
                el.innerHTML = qr.createSvgTag({cellSize: 4, margin: 1, scalable: true});
            } catch (err) {
                console.error('vip.js:: QR code: ' + err);
            }
        }
    }

    /* Portal's own data-members-signout binding wasn't firing on the account
       page, so the theme does the same request itself: the members session
       endpoint, then home. Not a reload - that would leave them sitting on a
       signed-out account page. */
    function handleSignout(event) {
        if (!event.target || !event.target.closest) {
            return;
        }

        var el = event.target.closest('[data-vip-signout]');

        if (!el) {
            return;
        }

        event.preventDefault();

        fetch('/members/api/session', {method: 'DELETE'})
            .then(function () {
                window.location.replace('/');
            })
            .catch(function (err) {
                console.error('vip.js:: sign out: ' + err);
            });
    }

    document.addEventListener('DOMContentLoaded', renderQrCodes);
    document.addEventListener('click', handleSignout);
})();
